<template>
  <div class="app-container">
    <transition name="fade" mode="out-in">
      <router-view @formDataActionCalled="formDataActionCalled" />
    </transition>
  </div>
</template>

<script>
import menu from '@/utils/menu'
import * as appTypes from '@/store/actions/app'

export default {
  name: 'container',
  props: [
    'type',
    'content'
  ],
  methods: {
    formDataActionCalled (stay) {
      if (!stay) {
        this.goToParentMenu()
      }
    },
    goToParentMenu () {
      var path = this.$route.matched[this.$route.matched.length - 1].path
      var menuParent = menu.methods.getDefaultParentMenuPath(null, this.$store.getters[`${appTypes.APP_NAMESPACE}/${appTypes.APP_CURRENT_MENU}`], path)
      this.$router.push(menuParent.parentContextPath + menuParent.contextPath).catch(() => {})
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/container/index.vue